import axios from 'src/utils/axios';

export default function v2_actionCriarLista(data) {
    return axios.post('/api/v2/cadastro/contatos/listas/criar', data);
}
